import script from "./customFieldList.vue?vue&type=script&setup=true&lang=js"
export * from "./customFieldList.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=2745aefa&scoped=true&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2745aefa"]])

export default __exports__